
let unique = 0
const uuid = (prefix) => {
  const time = Date.now()
  const random = Math.floor(Math.random() * 1000000000)
  unique++

  return prefix + '_' + random + unique + String(time)
}

const initEditor = (initEvent, ctx, editor) => {
  const value = ctx.$props.value ? ctx.$props.value : ''
  const initialValue = ctx.$props.initialValue ? ctx.$props.initialValue : ''
  editor.setContent(value || initialValue)

  if (ctx.$listeners.input) {
    bindModelHandlers(ctx, editor)
  }
}

const bindModelHandlers = (ctx, editor) => {
  const modelEvents = ctx.$props.modelEvents ? ctx.$props.modelEvents : null
  const normalizedEvents = Array.isArray(modelEvents) ? modelEvents.join(' ') : modelEvents

  ctx.$watch('value', (val, prevVal) => {
    if (editor && typeof val === 'string' && val !== prevVal && val !== editor.getContent()) {
      editor.setContent(val)
    }
  })

  editor.on(normalizedEvents || 'change keyup undo redo', () => {
    ctx.$emit('input', editor.getContent({ format: ctx.$props.outputFormat }))
  })
}

export {
  bindModelHandlers,
  initEditor,
  uuid,
}
